var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.statistics)?_c('div',[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":6}},[_c('el-statistic',{attrs:{"group-separator":",","precision":2,"value":_vm.statistics.errorpercent?parseFloat(_vm.statistics.errorpercent):0,"title":"异常占比(%)"}})],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }